import { technologiesData } from "@/mocks/homeData";

export default function TechnologiesSection() {
  return (
    <section id="technologies" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Technical Breadth
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {technologiesData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {technologiesData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {technologiesData.categories.map((cat) => (
            <div
              key={cat.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h4 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-4">
                {cat.name}
              </h4>
              <div className="flex flex-wrap gap-2">
                {cat.techs.map((tech) => (
                  <span
                    key={tech}
                    className="px-3 py-1.5 text-xs md:text-sm font-medium rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}